import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateConditionsRequestMapping } from "../../mapping/updateConditionsRequestMapping.js";

//** For the response, we need to map through the interviewAuraOutcomeMapping - interviewAuraOutcomeMapping */
import { interviewAuraOutcomeMapping } from "../../mapping/interviewAuraOutcomeMappingResponse.js";

import useSharedData from "../useSharedData.ts";

//** Axios request */
import { request } from "../../utilities/axios-utils.js";

//----------------------------------------------------------------
const putUpdateConditions = async (requestData) => {
	if (requestData == null) {
		return;
	}

	try {
		const { updateData, accessToken } = { ...requestData };
		const isDev = false; //! TODO: ENSURE THIS IS SET TO FALSE

		//! This has to come from the Policy Outcome stage of a CC flow.
		//! and can be found in the header of the request header (on updateQuote)
		const tempAccessToken =
			"eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJodHRwczovL2Rldi5lbGlmZWluc3VyZS5jb20uYXUvb2F1dGgyL3Rva2VuIiwiaXNzIjoidGVybWxpZmUtYXBpLmRldiIsInN1YiI6InRlcm1saWZlLWFwaS5kZXYuand0IiwiaWF0IjoxNzE1NTU1MjQ1LCJleHAiOjE3MTU1ODQwNDUsImp0aSI6IjNmYjMxODc2LTU2YjQtNDgyNS05OWM1LWFiODQ1MjA5NDJhOCIsInFpZCI6IjYzNFE3MDA0Mjg2QUxQIiwiZWx0aWQiOiI4ZjYxZmY4Ny03NzEyLTRmZWItYmVkZi0wZTAwYTkyMjM4MGQiLCJva3RhVXNlcklkIjoiMDB1NDYwNmJ6ZGJrcWZKQXYzbDciLCJjY191c2VyIjp0cnVlLCJ1c2VybmFtZSI6ImpjcWIiLCJmaXJzdE5hbWUiOiJDb2xpbiIsImxhc3ROYW1lIjoiQnlybmUifQ.t6dHyjc-bbLp5JHL6Jl0Mdshc-VqcRxyBluPc00VHfI";

		const jwtAccessToken = isDev === true ? tempAccessToken : accessToken;

		let mappedRequest = await updateConditionsRequestMapping(updateData);

		const response = await request({
			url: "/updateConditions",
			method: "PUT",
			data: JSON.stringify(mappedRequest),
			accessToken: jwtAccessToken,
		});
		if (200 === response?.status) {
			let newBusinessData = interviewAuraOutcomeMapping(response?.data);
			return newBusinessData;
		} else {
			throw response;
		}
	} catch (error) {
		console.error("Update Conditions Error ", error);
		throw error;
	}
};

export const useUpdateConditionsMutation = () => {
	const queryClient = useQueryClient();
	const { openErrorModal } = useSharedData();

	return useMutation({
		mutationFn: (data) => {
			return putUpdateConditions(data);
		},
		onSuccess: (data) => {
			//* Save the response to the TanStack cache.
			if (data != null) {
				queryClient.invalidateQueries(["premiumProjectionData"]);
			} else {
				openErrorModal();
			}
		},
		onError: (err) => {
			openErrorModal();
			// Do something when an error is thrown
			console.log("Error", err);
		},
	});
};
